import { allowedRoles } from './allowed-roles.js';
/**
 * Marshal a list of permission objects into their string equivalents.
 *
 * @param permissions - A list of permission objects
 */
export function encodePermissionsList(permissions) {
    return permissions.map(({ workspaceId, role }) => {
        return `${workspaceId}_${role}`;
    });
}
/**
 * Unmarshal a list of permission strings into a list of permission objects.
 *
 * @param permissions - A list of permission strings
 */
export function decodePermissionsList(permissions) {
    return permissions.map((permission) => {
        const [workspaceId, role] = permission.split('_');
        if (!allowedRoles.includes(role)) {
            throw Error(`Unknown role "${role}"`);
        }
        return { workspaceId, role };
    });
}
